import api from './api';

export const integrationsService = {
  get: () => api.get('/integrations'),
  update: (data) => api.put('/integrations', data),
  test: (channel) => api.post(`/integrations/test/${channel}`),
};
